import EmblaCarousel, { EmblaCarouselType, EmblaOptionsType } from 'embla-carousel';

export default class CardCarousel {
    private readonly embla: EmblaCarouselType;

    constructor(container: HTMLElement) {
        this.embla = EmblaCarousel(container, {
            containScroll: 'trimSnaps',
        });
    }

    static createFromSelector(selector: string) {
        return Array.from(document.querySelectorAll<HTMLElement>(selector)).map(container => {
            return new CardCarousel(container);
        });
    }
}
